const VERSION_PATTERN = /\d+(?:\.\d+){1,3}/;
export const APP_CODE = 'k-edu-talk';
export const APP_STORE_URLS = {
  ios: 'https://apps.apple.com/kr/app/ai-k-edu-talk/id6760539002',
  android: 'https://play.google.com/store/apps/details?id=com.mathautogen.kuesbtalk'
};
const toVersionParts = (value) => {
  const matchedVersion = String(value || '').match(VERSION_PATTERN)?.[0] || '';
  return matchedVersion
    ? matchedVersion.split('.').map((part) => Number.parseInt(part, 10) || 0)
    : [];
};

export const extractAppVersion = (value) => (
  String(value || '').match(VERSION_PATTERN)?.[0] || ''
);

export const compareAppVersions = (left, right) => {
  const leftParts = toVersionParts(left);
  const rightParts = toVersionParts(right);
  const maxLength = Math.max(leftParts.length, rightParts.length);

  for (let index = 0; index < maxLength; index += 1) {
    const leftPart = leftParts[index] || 0;
    const rightPart = rightParts[index] || 0;

    if (leftPart > rightPart) return 1;
    if (leftPart < rightPart) return -1;
  }

  return 0;
};

export const detectMobilePlatform = (...values) => {
  const platformText = values
    .filter(Boolean)
    .map((value) => String(value))
    .join(' ');

  if (/ios|iphone|ipad|ipod/i.test(platformText)) return 'ios';
  if (/android/i.test(platformText)) return 'android';
  return '';
};

// 모바일 브라우저의 OS만으로는 설치 앱의 버전 전달을 기다리지 않는다.
export const isNativeAppEnvironment = ({
  deviceKind = '',
  userAgent = '',
  hasAndroidBridge = false,
  hasIosBridge = false
} = {}) => Boolean(
  detectMobilePlatform(deviceKind)
  || hasAndroidBridge
  || hasIosBridge
  || /;\s*wv\)/i.test(userAgent)
  || (/iPhone|iPad|iPod/i.test(userAgent)
    && /AppleWebKit/i.test(userAgent)
    && !/Safari|CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent))
);

export const getAppUpdateRequirement = (installedVersionText, release) => {
  const installedVersion = extractAppVersion(installedVersionText);
  const lastVersion = extractAppVersion(release?.lastVersion);

  if (!installedVersion || !lastVersion || !release?.storeUrl) {
    return null;
  }

  if (compareAppVersions(installedVersion, lastVersion) >= 0) {
    return null;
  }

  return {
    ...release,
    installedVersion,
    lastVersion
  };
};
